import apiClient from '@/axios/app-client';
import { FunctionName, PermissionAction } from '@/lib/enums';

export interface Company {
  id: string;
  partnerClassification: number;
  name: string;
}

const COMPANIES_ENDPOINT = '/v1/companies';

/**
 * Companies Service
 * Handles API calls for companies by partner classification
 */
export const companiesService = {
  /**
   * Get companies by partner classification
   * @param partnerClassification - 1: Customer, 2: Supplier, 3: Construction, 4: Witness
   */
  getCompaniesByClassification: async (
    partnerClassification: number,
    functionName: FunctionName,
    permissionAction?: PermissionAction
  ): Promise<Company[]> => {
    const permissionActionParam = permissionAction ? `&permissionAction=${permissionAction}` : '';
    const response = await apiClient.get<Company[]>(
      `${COMPANIES_ENDPOINT}/${partnerClassification}?functionName=${functionName}${permissionActionParam}`
    );
    return response.data.data;
  },

  /**
   * Get companies by partner classification and supplier type
   * @param partnerClassification - Partner classification (typically 2 for Supplier)
   * @param supplierType - Supplier type (e.g., 3 for Plant/プラント)
   */
  getCompaniesByClassificationAndType: async (
    partnerClassification: number,
    supplierType: number,
    functionName: FunctionName,
    permissionAction?: PermissionAction
  ): Promise<Company[]> => {
    const permissionActionParam = permissionAction ? `&permissionAction=${permissionAction}` : '';
    const response = await apiClient.get<Company[]>(
      `${COMPANIES_ENDPOINT}/${partnerClassification}?supplierType=${supplierType}&functionName=${functionName}${permissionActionParam}`
    );
    return response.data.data;
  },
};
